import { AdminLayout } from "@/layouts/AdminLayout";
import { createInertiaApp } from "@inertiajs/react";
import { createElement, type ReactNode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";

// Temporary type definition, until @inertiajs/react provides one
type ResolvedComponent = {
  default: ReactNode;
  layout?: (page: ReactNode) => ReactNode;
};

createInertiaApp({
  title: (title) => (title ? `${title} | blpnt` : "blpnt"),
  resolve: (name) => {
    const pages = import.meta.glob<ResolvedComponent>("../pages/**/*.tsx", {
      eager: true,
    });
    const page = pages[`../pages/${name}.tsx`];
    // Only provide the admin layout when the page has not selected its own.
    // Without the explicit grouping, the ternary replaces any existing layout
    // (including SessionFormsLayout) with AdminLayout.
    // @ts-ignore
    page.default.layout =
      // @ts-ignore
      page.default.layout ||
      (name.toLowerCase().startsWith("admin/")
        ? (page: ReactNode) => <AdminLayout children={page} />
        : undefined);

    return page;
  },
  setup({ el, App, props }) {
    if (el) {
      // Hydrate only in prod, as in dev it's painful to keep reloading servers.
      if (import.meta.env.DEV) {
        createRoot(el).render(createElement(App, props));
      } else {
        hydrateRoot(el, createElement(App, props));
      }
    } else {
      console.error(
        "Missing root element.\n\n" +
          "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
          'Consider moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.'
      );
    }
  },
});
